import "./App.css";
import { LandingSearchBar } from "./components/search-bar/landing-search-bar";
import { ContractorManager } from "./modules/contractor-manager";

//Conditionally handle whether the full tool is rendered or just the search bar
// if <path> render the full search page component

const SearchRoute = () => {
    if (window.location.pathname === "/business-industry/find-a-contractor/") {
        return (
          <LandingSearchBar />
        )} else {
        return (
          <ContractorManager /> 
      )}
}

function App() {
  return (
    <>
        {SearchRoute()}
    </>
    
  );
}

export default App;
